module.exports = __webpack_public_path__ + "img/img-1.f7654ff0.png";